import { useEffect } from 'react';
import { PAGE_DEFAULT_COLOR } from '~/components/Page';

export const usePageColor = ( color: string, deps: Parameters<typeof useEffect>['1'] = [] ) => {
  useEffect( () => {
    document.documentElement.style.setProperty( '--page-color', color );

    return () => {
      document.documentElement.style.setProperty( '--page-color', PAGE_DEFAULT_COLOR );
    }
  }, deps );
}
